/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Edit Provider Button
 */
import { Tooltip, Button, ButtonProps } from 'antd';
import { Link } from 'react-router-dom';
import { Edit } from '@icon-park/react';

import { getEditProviderPath } from 'utils/router';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

/**
 * EditProvider Link
 * @param props
 */
const EditProviderLink: React.FC<ILinkProps> = (props) => {
	const { children, id, ...restProps } = props;

	return (
		<Link {...restProps} to={getEditProviderPath(id)}>
			{children}
		</Link>
	);
};

/**
 * EditProvider
 *
 */
const EditProvider: React.FC<{ providerId: string } & ButtonProps> = ({ providerId, ...restProps }) => {
	const { canEditProviders } = useAppStoreValues().userAccess;
	const disabled = restProps.disabled || !canEditProviders;
	const editButton = (
		<Tooltip title={`${canEditProviders ? 'Edit Provider' : NO_ACCESS_TOOLTIP_TEXT}`}>
			<Button color='default' icon={<Edit />} {...restProps} disabled={disabled}>
				{'Edit'}
			</Button>
		</Tooltip>
	);

	if (providerId && canEditProviders) {
		return (
			<EditProviderLink key='edit-provider' id={providerId}>
				{editButton}
			</EditProviderLink>
		);
	}

	return editButton;
};

export { EditProviderLink };
export default EditProvider;
